import React, { useEffect, useState } from 'react';
import Breadcrumb from '../../../components/Breadcrumb';
import {
  createNewTransaction,
  updateNewTransaction,
  getNewTransactionById,
} from '../../../axios/NewTransaction';
import Swal from 'sweetalert2';
import { Link, useNavigate, useParams } from 'react-router-dom';

export const NewTransactionAdd = () => {
  const navigation = useNavigate();
  const { id } = useParams();

  const [formData, setFormData] = useState({
    project_id: '',
    name: '',
    location: '',
    range: '',
    qty: '',
    approval: '',
  });

  const [breadcrumbItems, setBreadcrumbItems] = useState([
    { label: 'Dashboard', href: '/' },
    { label: 'New Transaction', href: '/new-transaction' },
    { label: 'Create New Transaction' },
  ]);

  // Set breadcrumb based on the presence of 'id'
  useEffect(() => {
    if (id) {
      setBreadcrumbItems([
        { label: 'Dashboard', href: '/' },
        { label: 'New Transaction', href: '/new-transaction' },
        { label: 'Update New Transaction' },
      ]);
    }
  }, [id]);

  useEffect(() => {
    if (id) {
      const fetchNewTransactionData = async () => {
        try {
          const response = await getNewTransactionById(id); // Get data by ID from backend
          setFormData(response); // Populate form with fetched data
        } catch (error) {
          console.error('Error fetching new transaction data:', error);
        }
      };
      fetchNewTransactionData();
    }
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.target;
    if (!form.checkValidity()) {
      form.classList.add('was-validated');
      return;
    }

    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-primary mx-1', // Bootstrap primary button
        denyButton: 'btn btn-danger mx-1', // Bootstrap warning button
        cancelButton: 'btn btn-secondary mx-1', // Bootstrap secondary button
      },
      buttonsStyling: false,
    });

    try {
      const result = await swalWithBootstrapButtons.fire({
        title: 'Do you want to save the data?',
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: 'Save',
        cancelButtonText: `Don't save`,
      });

      if (result.isConfirmed) {
        try {
          if (id) {
            await updateNewTransaction(id, formData);
            swalWithBootstrapButtons.fire(
              'Saved!',
              'The new transaction has been updated.',
              'success'
            );
          } else {
            await createNewTransaction(formData);
            // Jika berhasil, tampilkan pesan sukses
            swalWithBootstrapButtons.fire(
              'Saved!',
              'The new transaction has been created.',
              'success'
            );
          }
          navigation('/new-transaction');
        } catch (createNewTransacError) {
          // Jika ada kesalahan saat membuat akun, tampilkan pesan kesalahan
          swalWithBootstrapButtons.fire({
            title: 'Error!',
            text: createNewTransacError.message,
            icon: 'error',
          });
        }
      } else if (result.isDenied) {
        swalWithBootstrapButtons.fire('Changes are not saved', '', 'info');
      }
    } catch (error) {
      swalWithBootstrapButtons.fire({
        title: 'Error!',
        text: 'There was an error processing your request.',
        icon: 'error',
      });
      console.log(error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      const formElements = Array.from(e.target.form.elements);
      const index = formElements.indexOf(e.target);
      formElements[index + 1]?.focus();
    }
  };

  const handleCancel = (event) => {
    event.preventDefault();

    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-primary mx-1', // Bootstrap primary button
        denyButton: 'btn btn-danger mx-1', // Bootstrap warning button
        cancelButton: 'btn btn-secondary mx-1', // Bootstrap secondary button
      },
      buttonsStyling: false,
    });
    swalWithBootstrapButtons
      .fire({
        title: 'Are you sure?',
        text: 'All your input will be lost!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, cancel it!',
        cancelButtonText: 'No, keep it',
      })
      .then((result) => {
        if (result.isConfirmed) {
          const form = document.querySelector('.needs-validation');
          form.reset();
          setFormData({
            project_id: '',
            name: '',
            location: '',
            range: '',
            qty: '',
            approval: '',
          });
          form.classList.remove('was-validated');
        }
      });
  };

  return (
    <div>
      <Breadcrumb items={breadcrumbItems}></Breadcrumb>
      <form className="needs-validation" noValidate onSubmit={handleSubmit}>
        <div className="row">
          <div className="col-sm-6">
            <div className="card">
              <div className="card-body">
                <div className="mb-3">
                  <label htmlFor="validationExtCode" className="form-label">
                    Project ID
                  </label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    id="validationExtCode"
                    name="project_id"
                    value={formData.project_id}
                    onChange={handleChange}
                    onKeyDown={handleKeyDown}
                    required
                  />
                  <div className="invalid-feedback">Cannot be empty.</div>
                </div>
                <div className="mb-3">
                  <label className="form-label">Name</label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    id="validationName"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    onKeyDown={handleKeyDown}
                    required
                  />
                  <div className="invalid-feedback">Cannot be empty.</div>
                </div>
                <div className="mb-3">
                  <label className="form-label">Location</label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    id="validationNPWP"
                    name="location"
                    value={formData.location}
                    onChange={handleChange}
                    onKeyDown={handleKeyDown}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="col-sm-6">
            <div className="card">
              <div className="card-body">
                <div className="mb-3">
                  <label className="form-label">Range</label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    name="range"
                    value={formData.range}
                    onChange={handleChange}
                    onKeyDown={handleKeyDown}
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">QTY</label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    name="qty"
                    value={formData.qty}
                    onChange={handleChange}
                    onKeyDown={handleKeyDown}
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Approval</label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    name="approval"
                    value={formData.approval}
                    onChange={handleChange}
                    onKeyDown={handleKeyDown}
                  />
                </div>
              </div>
            </div>
            <div className="button-navigatsi">
              <div className="">
                <button type="submit" className="btn btn-primary">
                  <i className="bi bi-send"></i>
                  <span> Submit</span>
                </button>
              </div>
              <div className="">
                <button
                  type="reset"
                  className="btn btn-danger btn-cancel"
                  onClick={handleCancel}
                >
                  <i className="bi bi-x-circle"></i>
                  <span> Cancel</span>
                </button>
              </div>
              <div className="">
                <Link
                  type="button"
                  className="btn btn-warning"
                  to="/new-transaction"
                >
                  <i className="bi bi-arrow-left-circle"></i>
                  <span> Back</span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};
